import React, { memo, useCallback, useEffect, useState } from 'react';
import { createUseStyles, Switch } from '@Sage/hoi-poi-ui';

import {
    applyLineSmartFieldOverridesToInputParams,
    getLineSmartFieldOverrides,
} from './applyLineSmartFieldOverrides';
import styles from './styles';

const useStyles = createUseStyles(styles, 'SwitchCell');

const isEmptyValue = (value) => value === null || value === undefined || value === '';

const resolveChecked = (value, defaultValue) => Boolean(isEmptyValue(value) ? defaultValue : value);

const SwitchCell = memo((params) => {
    const [isChecked, setIsChecked] = useState(() =>
        resolveChecked(params.value, params.inputParams?.defaultValue),
    );
    const classes = useStyles();

    const field = params.colDef.field;
    const lineOverrides = getLineSmartFieldOverrides(params.data, field);
    const resolvedInputParams = applyLineSmartFieldOverridesToInputParams(
        params.inputParams,
        lineOverrides,
    );
    const { onChange, ...inputParams } = resolvedInputParams || {};
    const isReadOnly = !!inputParams.isReadOnly;

    useEffect(() => {
        setIsChecked(resolveChecked(params.value, inputParams.defaultValue));
    }, [inputParams.defaultValue, params.value]);

    const handleOnChange = useCallback(() => {
        if (isReadOnly) return;
        const id = params.data.id || params.data.Id || params.data.ID || '';
        const value = !isChecked;
        onChange({ rowIndex: params.node.rowIndex, id, field, value });
        setIsChecked(value);
    }, [field, isChecked, isReadOnly, onChange, params]);

    if (!params.inputParams) return null;

    return (
        <div className={['w5-cell', classes.editableCell].join(' ')}>
            <div className={classes.switchCell}>
                <Switch {...inputParams} checked={isChecked} onChange={handleOnChange} />
            </div>
        </div>
    );
});

export default SwitchCell;
